import React, { useEffect, useState, Fragment, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Select, Dropdown, Tag, Drawer, Menu, notification } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import JobWorkActions from '@Actions/production/jobWorkActions';
import H3Text from '@Uilib/h3Text';
import TemplateRouteActions from '@Actions/production/templateRouteActions';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3DateSelector from '@Uilib/h3DateSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import SelectUser from '@Components/Common/SelectUser';
import TenantActions from '@Actions/tenantActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import KanbanView from '@Components/Production/JobWorks/KanbanView';
import JobWorksList from '@Components/Production/JobWorks/JobWorksList';
import POForm from '@Components/Purchase/PurchaseOrders/POForm';
import ViewJobWork from '@Components/Production/JobWorks/ViewJobWork';
import ResourceActions from '@Actions/production/resourceActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import SelectSeller from '@Components/Common/SelectSeller';
import InvoiceForm from '@Components/Sales/Invoice/InvoiceForm';
import dayjs from 'dayjs';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import { getPoLinesFromJobWorks, getInvoiceLinesFromJobWorks } from './helpers';
import PRZSelect from '../../Common/UI/PRZSelect';
import './style.scss';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../apis/constants';
import UserSavedFilterViewSelector from '../../Common/UserSavedFilterViewSelector';
import useCheckPortrait from '../../../hooks/useCheckPortrait';

const { Option } = Select;

/**
 *
 */
function JobWorks({
  user, history, getJobWorks, departments,
  jobWorks, getOrgUsers,
  orgUsers, getJobOperators, dropdownResources, getResourceGroup,
  resourcesGroup, getResourceGroupLoading, getResource, getDocCFV2,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isUserReady, setIsUserReady] = useState(false);
  const [call, setCall] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(['PENDING', 'IN_PROGRESS', 'PAUSED']);
  const [moStatus, setMOStatus] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [selectedAssignee, setSelectedAssignee] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [route, setRoute] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [groupBy, setGroupBy] = useState(localStorage.getItem('prcz-jw-gb') || 'machine');
  const [showJobInvoice, setShowJobInvoice] = useState(false);
  const [viewType, setViewType] = useState(localStorage.getItem('prcz-jw-vt') || 'list');
  const [showJobWork, setShowJobWork] = useState(false);
  const [selectedJobWorkId, setSelectedJobWorkId] = useState('');
  const [selectedResourceGroup, setSelectedResourceGroup] = useState(null);
  const [selectedResource, setSelectedResource] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [showPoForm, setShowPoForm] = useState(false);
  const [jwPoPayload, setJwPoPayload] = useState(false);
  const [jwInvoicePayload, setJwInvoicePayload] = useState([]);
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [jwDateSelectedIntervalDateRangeType, setJwDateSelectedIntervalDateRangeType] = useState('');
  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();
  const orderStatues = [
    { value: 'DRAFT', label: 'Draft' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'PAUSED', label: 'Paused' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'VOID', label: 'Void' },
    { value: 'BLOCKED ', label: 'Blocked' },
  ];

  const manufacturingOrderStatues = [
    { value: 'CONFIRMED', label: 'Confirmed' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'DRAFT', label: 'Draft' },
    { value: 'COMPLETED', label: 'Closed' },
    { value: 'VOID', label: 'Void' },
  ];

  const orderStatusOptionsManufacturingOrders = [
    { key: null, value: null, label: 'All Order Status' },
    ...(manufacturingOrderStatues?.map(item => ({
      key: item,
      value: item.value,
      label: item.label,
    })) || []),
  ];

  const pushParamsToUrl = (page, limit, word, status, moStatus, currentTenant, startDate, endDate, dept, route, assignee, selectedResourceGroup, selectedResource, selectedVendor, jwDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (word) url += `&keyword=${word}`;
    if (status) url += `&status=${status}`;
    if (moStatus) url += `&mo_status=${moStatus}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    if (jwDateSelectedIntervalDateRangeType) url += `&jw_date_type=${jwDateSelectedIntervalDateRangeType}`;
    if (dept) url += `&department=${dept}`;
    if (route) url += `&route=${route}`;
    if (selectedResourceGroup) url += `&resource_group_id=${selectedResourceGroup}`;
    if (selectedResource) url += `&resource_id=${selectedResource}`;
    if (assignee) url += `&assignee=${selectedAssignee?.map((item) => (item?.userId))?.join(',')}`;
    if (selectedVendor) url += `&subcontract_seller_id=${selectedVendor}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {
    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',')?.filter((item) => (viewType === 'kanban' ? item !== 'COMPLETED' : true)) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'mo_status',
        filter_value: Helpers.getValueFromUrl('mo_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('jw_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('jw_date_type') || '',
      },
      {
        filter_key: 'department',
        filter_value: Number(Helpers.getValueFromUrl('department')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'route',
        filter_value: Number(Helpers.getValueFromUrl('route')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'resource_group_id',
        filter_value: Number(Helpers.getValueFromUrl('resource_group_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'resource_id',
        filter_value: Number(Helpers.getValueFromUrl('resource_id')) || null,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'assignee',
        filter_value: Helpers.getValueFromUrl('assignee') ? Helpers.getValueFromUrl('assignee')?.split(',')?.map((item) => ({
          userId: parseInt(item),
          title: parseInt(item) == 0 ? 'Unassigned' : `${orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name}`?.trim(),
          identity: parseInt(item) == 0 ? 'UA' : orgUsers?.data?.find((i) => i?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
        })) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'subcontract_seller_id',
        filter_value: Helpers.getValueFromUrl('subcontract_seller_id') || null,
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => [
    {
      filter_key: 'limit',
      filter_value: limit,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'keyword',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'status',
      filter_value: ['PENDING', 'IN_PROGRESS', 'PAUSED'],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'mo_status',
      filter_value: '',
      filter_type: filterTypeEnums.STRING,
    },
    {
      filter_key: 'tenant',
      filter_value: [user?.tenant_info?.tenant_id],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'startDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'endDate',
      filter_value: '',
      filter_type: filterTypeEnums.DATE_RANGE,
      date_range_type: '',
    },
    {
      filter_key: 'department',
      filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'route',
      filter_value: '',
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'resource_group_id',
      filter_value: null,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'resource_id',
      filter_value: null,
      filter_type: filterTypeEnums.NUMBER,
    },
    {
      filter_key: 'assignee',
      filter_value: [],
      filter_type: filterTypeEnums.ARRAY,
    },
    {
      filter_key: 'subcontract_seller_id',
      filter_value: null,
      filter_type: filterTypeEnums.NUMBER,
    },
  ], []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.JOB_CARDS,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }

        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedStatus(tempFilterValues.status);
        setMOStatus(tempFilterValues.mo_status);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedAssignee(tempFilterValues.assignee);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setJwDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setRoute(tempFilterValues.route);
        setSelectedResourceGroup(tempFilterValues.resource_group_id);
        setSelectedResource(tempFilterValues.resource_id);
        setSelectedVendor(tempFilterValues.subcontract_seller_id);
        setSelectedDepartment(tempFilterValues.department);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
    // setLimit(Helpers.getValueFromUrl('limit') || limit);
    // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
    // setKeyword(Helpers.getValueFromUrl('keyword'));
    // setSelectedStatus(Helpers.getValueFromUrl('status') ? Helpers.getValueFromUrl('status')?.split(',')?.filter((item) => (viewType === 'kanban' ? item !== 'COMPLETED' : true)) : ['PENDING', 'IN_PROGRESS', 'PAUSED']);
    // setMOStatus(Helpers.getValueFromUrl('mo_status'));
    // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
    // setSelectedAssignee(Helpers.getValueFromUrl('assignee') ? Helpers.getValueFromUrl('assignee')?.split(',')?.map((item) => ({
    //   userId: parseInt(item),
    //   title: `${orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name}`?.trim(),
    //   identity: orgUsers?.data?.find((i) => item?.user_id === parseInt(item))?.first_name?.substring(0, 2).toUpperCase(),
    // })) : []);
    // setStartDate(Number(Helpers.getValueFromUrl('startDate')));
    // setEndDate(Number(Helpers.getValueFromUrl('endDate')));
    // setRoute(Number(Helpers.getValueFromUrl('route')));
    // setSelectedResourceGroup(Number(Helpers.getValueFromUrl('resource_group_id')) || null);
    // setSelectedResource(Number(Helpers.getValueFromUrl('resource_id')) || null);
    // setSelectedVendor(Number(Helpers.getValueFromUrl('subcontract_seller_id')) || null);
    // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
    //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
    //   setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
    // } else {
    //   setSelectedDepartment(Helpers.getValueFromUrl('department'));
    // }
    // setIsUserReady(true);

    // for batch custom fields in JwQuantityUpdate
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'MANUFACTURING_ORDER,BATCH',
    };
    getDocCFV2(payload);
  }, []);

  /**
   *
   */
  useEffect(() => {
    if (isUserReady) {
      getJobOperators({ orgId: user?.tenant_info?.org_id });
      getResourceGroup(user?.tenant_info?.org_id);
      getResource(user?.tenant_info?.org_id, 1, 100, '', selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ)?.join(','), '', '', true);
      pushParamsToUrl(currentPage, limit, searchKeyword, selectedStatus, moStatus, selectedTenant, startDate, endDate, selectedDepartment, route, selectedAssignee, selectedResourceGroup, selectedResource, selectedVendor, jwDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getJobWorks({
        orgId: user?.tenant_info?.org_id,
        tenantId: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ)?.join(','),
        departmentId: Helpers.getValueFromUrl('department'),
        status: Helpers.getValueFromUrl('status'),
        moStatus: Helpers.getValueFromUrl('mo_status'),
        route: Helpers.getValueFromUrl('route'),
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        searchKeyword: Helpers.getValueFromUrl('keyword'),
        startDate: Helpers.getValueFromUrl('startDate'),
        endDate: Helpers.getValueFromUrl('endDate'),
        assignee: Helpers.getValueFromUrl('assignee'),
        resourceId: Helpers.getValueFromUrl('resource_id'),
        resourceGroupId: Helpers.getValueFromUrl('resource_group_id'),
        sellerId: Helpers.getValueFromUrl('subcontract_seller_id'),
        isListScreen: true,
      }, () => { });
    }
  }, [call]);

  useEffect(() => {
    setCall(!call);
  }, [searchKeyword, currentPage, selectedStatus, moStatus, selectedTenant, startDate, endDate, selectedDepartment, selectedAssignee, limit, selectedResourceGroup, selectedResource, selectedVendor, jwDateSelectedIntervalDateRangeType,
    // selectedFilterView
  ]);

  useEffect(() => {
    getOrgUsers(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ)?.join(','), () => { });
  }, [selectedTenant]);

  const issueRawMaterials = (issueType) => {
    const uniqueVendors = new Set();
    const uniqueTenants = new Set();
    let hasError = false;
    selectedRows?.map((row) => {
      if (row?.seller_info?.seller_id) {
        uniqueVendors.add(row?.seller_info?.seller_id)
      }
      if (row?.tenant_info?.tenant_id) {
        uniqueTenants.add(row?.tenant_info?.tenant_id)
      }
    })

    if (uniqueVendors.size > 1) {
      notification.open({
        type: 'error',
        message: 'Please select job cards of single subcontractor only in order to create work orders in bulk',
        placement: 'top',
        duration: 4
      })
      hasError = true;
    }

    if (uniqueTenants.size > 1) {
      notification.open({
        type: 'error',
        message: 'Please select job cards of single location in order to issue raw materials in bulk.',
        placement: 'top',
        duration: 4
      })
    }

    if (!hasError) {
      const jwInvoicePayload = getInvoiceLinesFromJobWorks(selectedRows, issueType);
      setJwInvoicePayload(jwInvoicePayload);
      setShowJobInvoice(true);
    }
  }

  const createWorkOrders = (issueType) => {
    const uniqueVendors = new Set();
    const uniqueTenants = new Set();
    let hasError = false;
    selectedRows?.map((row) => {
      if (row?.seller_info?.seller_id) {
        uniqueVendors.add(row?.seller_info?.seller_id)
      }
      if (row?.tenant_info?.tenant_id) {
        uniqueTenants.add(row?.tenant_info?.tenant_id)
      }
    })

    if (uniqueVendors.size > 1) {
      notification.open({
        type: 'error',
        message: 'Please select job cards of single subcontractor only in order to create work orders in bulk',
        placement: 'top',
        duration: 4
      })
      hasError = true;
    }

    if (uniqueTenants.size > 1) {
      notification.open({
        type: 'error',
        message: 'Please select job cards of single location in order to issue raw materials in bulk.',
        placement: 'top',
        duration: 4
      })
    }

    if (!hasError) {
      const jwPayload = getPoLinesFromJobWorks(selectedRows, issueType);
      setJwPoPayload(jwPayload);
      setShowPoForm(true);
    }
  }

  const groupByOptions = [
    { label: 'Group By Machine', value: 'machine' },
    { label: 'Group By Work Center', value: 'work_center' },
    { label: 'Group By Operator', value: 'operator' },
  ];

  const viewOptions = [
    { label: 'List View', value: 'list' },
    { label: 'Grid View', value: 'kanban' },
  ];

  return (
    <Fragment>
      <Drawer />
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Job Cards..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setMOStatus(tempFilterValues.mo_status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedAssignee(tempFilterValues.assignee);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setJwDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setRoute(tempFilterValues.route);
                    setSelectedResourceGroup(tempFilterValues.resource_group_id);
                    setSelectedResource(tempFilterValues.resource_id);
                    setSelectedVendor(tempFilterValues.subcontract_seller_id);
                    setSelectedDepartment(tempFilterValues.department);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.JOB_CARDS}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search for
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedStatus && selectedStatus?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedStatus(selectedStatus.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Status -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()?.replaceAll('_', ' ')}</b>
                    </span>
                  </Tag>
                ))}
                {moStatus && (
                  <Tag closable onClose={() => { setMOStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Order Status -
                    &nbsp;
                    <span><b>{moStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setJwDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {selectedResource ? (
                  <Tag closable onClose={() => { setSelectedResource(null); setCurrentPage(1); }} color="#2d7df7">
                    Machine -
                    &nbsp;
                    <span><b>{dropdownResources?.data?.find((item) => item?.resource_id == selectedResource)?.resource_name}</b></span>
                  </Tag>
                ) : ''}
                {selectedResourceGroup ? (
                  <Tag closable onClose={() => { setSelectedResourceGroup(null); setCurrentPage(1); }} color="#2d7df7">
                    Work Center -
                    &nbsp;
                    <span><b>{resourcesGroup?.data?.find((item) => item?.resource_group_id == selectedResourceGroup)?.resource_group_name}</b></span>
                  </Tag>
                ) : ''}
                {selectedVendor && (
                  <Tag closable onClose={() => { setSelectedVendor(''); }} color="#2d7df7">
                    Subcontractor -
                    &nbsp;
                    <span><b>{jobWorks?.job_works?.[0]?.seller_info?.seller_name || 'NO JOB CARDS FOUND'}</b></span>
                  </Tag>
                )}
              </div>
            </div>  
            <div className="doc-list__table-wrapper">
              <div className="doc-list__table-header jw-table-header">
                <div className="doc-list__table-header__left">
                  <H3Text text={`${(jobWorks && jobWorks?.count) ? jobWorks?.count : '0'} Total Job Cards`} className="" />
                </div>
                <div className="doc-list__table-header__right">
                  <div className="doc-list__filter-buttons">
                    <div className="select-user__filter-wrapper">
                      <SelectUser
                        tenantId={selectedTenant?.join(',')}
                        selectedUsers={selectedAssignee}
                        onSelect={(userId) => {
                          setCurrentPage(1)
                          setSelectedAssignee([...selectedAssignee, {
                            userId,
                            title: `${orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name}`?.trim(),
                            identity: orgUsers?.data?.find((item) => item?.user_id === userId)?.first_name?.substring(0, 2).toUpperCase(),
                          }]);
                        }}
                        onRemove={(userId) => {
                          setSelectedAssignee([...selectedAssignee?.filter((item) => item?.userId !== userId)]);
                        }}
                      />
                    </div>
                    <div className="doc-list__action-buttons jw-list__action-buttons">
                      <PRZSelect
                        value={viewType}
                        filterOption={false}
                        onChange={(value) => {
                          setViewType(value);
                          localStorage.setItem('prcz-jw-vt', value);
                        }}
                        className="action-button jw-view-selector"
                        options={viewOptions}
                      />
                    </div>
                    {viewType === 'kanban' && (
                      <div className="action-buttons">
                        <PRZSelect
                          value={groupBy}
                          filterOption={false}
                          onChange={(value) => {
                            localStorage.setItem('prcz-jw-gb', value);
                            setGroupBy(value);
                          }}
                          showSearch={false}
                          className="action-button"
                          options={groupByOptions}
                        />
                      </div>
                    )}
                    {selectedRows?.length > 0 && viewType === 'list' && (
                      <Dropdown
                        overlay={(
                          <Menu>
                            <Menu.Item>
                              <div onClick={() => createWorkOrders('INPUT')}>
                                + Production Work Order
                              </div>
                            </Menu.Item>
                            <Menu.Item>
                              <div onClick={() => issueRawMaterials('INPUT')}>
                                + Issue Raw Materials
                              </div>
                            </Menu.Item>
                            <Menu.Item>
                              <div onClick={() => createWorkOrders('PROCESSING')}>
                                + Processing Work Order
                              </div>
                            </Menu.Item>
                            <Menu.Item>
                              <div onClick={() => issueRawMaterials('PROCESSING')}>
                                + Issue Processing Materials
                              </div>
                            </Menu.Item>
                          </Menu>
                        )}
                        placement="bottomLeft"
                        trigger={['click']}
                      // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      >
                        <div className="action-buttons">
                          <div className="action-button" style={{ padding: '0px 7px', fontWeight: '500', color: 'black' }}>
                            Actions
                            &nbsp;
                            <FontAwesomeIcon icon={faCaretDown} />
                          </div>
                        </div>
                      </Dropdown>

                    )}
                    <div className="jw-list__action-buttons">
                      <H3DateSelector
                        selectedInterval={jwDateSelectedIntervalDateRangeType}
                        startDate={startDate}
                        endDate={endDate}
                        onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                          setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                          setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                          setJwDateSelectedIntervalDateRangeType(dateRangeType);
                        }}
                      />
                    </div>
                    <div className="action-buttons jw-list__filter">
                      <div className="action-button" onClick={() => setShowFilters(true)}>
                        <H3Text text="Filters" className="action-button-text" />
                        <FilterOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {viewType === 'list' && (
                <JobWorksList
                  call={call}
                  setCall={setCall}
                  limit={limit}
                  setLimit={setLimit}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  selectedTenant={selectedTenant}
                  selectedRows={selectedRows}
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRows={setSelectedRows}
                  setSelectedRowKeys={setSelectedRowKeys}
                  setSelectedJobWork={(val) => {
                    setSelectedJobWorkId(val);
                    setShowJobWork(true);
                  }}
                />
              )}
              {
              viewType !== 'list' && (
                <KanbanView
                  user={user}
                  tenantIds={selectedTenant?.length ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.FACTORY_SETUP, Helpers.permissionTypes.READ)?.join(',')}
                  userIds={selectedAssignee?.map((item) => (item?.userId))?.join(',')}
                  status={selectedStatus}
                  groupBy={groupBy}
                  startDate={startDate}
                  endDate={endDate}
                  department={selectedDepartment}
                  moStatus={moStatus}
                  searchKeyword={searchKeyword}
                  setSelectedJobWork={(val) => {
                    setSelectedJobWorkId(val);
                    setShowJobWork(true);
                  }}
                  externalCall={call}
                  resourceGroup={selectedResourceGroup}
                  resource={selectedResource}
                />
              )
              }
            </div>
          </div>
        </div>
      </div>
      <Drawer
        onClose={() => {
          setShowJobInvoice(false);
        }}
        open={showJobInvoice}
        width="1040px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '995px' }}>
            <H3Text text="Issue Raw Material Invoices" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => {
              setShowJobInvoice(false);
            }} />
          </div>
        </div>
        <div className="job-work__issue-rm">
          <InvoiceForm
            tenantId={selectedTenant?.[0]}
            jwRmLines={jwInvoicePayload}
            tenantDepartmentId={user?.tenant_info?.default_department_for_production}
            jwCallback={() => {
              setCall(!call);
              setShowJobInvoice(false);
            }}
            isCarryForward={true}
          />
        </div>
      </Drawer>
      <Drawer
        onClose={() => setShowPoForm(false)}
        open={showPoForm}
        width="1100px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1050px' }}>
            <H3Text text="Send Work Order" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowPoForm(false)} />
          </div>
        </div>
        <POForm
          tenantId={selectedTenant?.[0]}
          jwInfo={jwPoPayload}
          moCallback={() => {
            setCall(!call);
            setShowPoForm(false)
          }}
        />
      </Drawer>
      <Drawer
        onClose={() => setShowJobWork(false)}
        open={showJobWork}
        width="840px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '795px' }}>
            <H3Text text="View Job Card" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowJobWork(false)} />
          </div>
        </div>
        <ViewJobWork jobworkId={selectedJobWorkId} selectedTenant={selectedTenant} callback={() => setCall(!call)} isQuickView/>
      </Drawer>
      <Drawer
        onClose={() => setShowFilters(false)}
        open={showFilters}
        width="380px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '335px' }}>
            <H3Text text="Apply Filters" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowFilters(false)} />
          </div>
        </div>
        <div className="header__filter__container header__filter__container-drawer">
          <div className="filter__container filter__container-section">
            <div className="filter__title"> Select Business Unit</div>
            <div className="job-works__header__section-status">
              <TenantSelector
                selectedTenant={selectedTenant}
                showSearch
                showAll={false}
                noDropdownAlign
                isMultiple
                onChange={(value) => {
                  setCurrentPage(1);
                  setSelectedTenant(value);
                }}
                placeholder="Select Business Unit"
                hideTitle
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)}
              />
            </div>
          </div>
          <div className="filter__container filter__container-section">
            <div className="filter__title"> Select Department</div>
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={Number(selectedDepartment) || ''}
              noDropdownAlign
              onChange={(value) => {
                setSelectedDepartment(value?.department_id.toString() || '');
                setCurrentPage(1);
              }}
              disabled={departmentLevelVisibility}
            />
          </div>
          <div className="filter__container filter__container-section">
            <div className="filter__title">Job Card Status</div>
            <PRZSelect
              value={selectedStatus}
              onChange={(value) => {
                setSelectedStatus(value);
                setCurrentPage(1);
              }}
              placeholder="Job Card Status"
              mode="multiple"
              maxTagCount="responsive"
            >
              {orderStatues
                ?.map((item) => (
                  <Option
                    key={item}
                    value={item.value}
                  >
                    {item.label}
                  </Option>
                ))}
            </PRZSelect>
          </div>
          <div className="filter__container filter__container-section">
            <div className="filter__title">Work Center</div>
            <PRZSelect
              value={selectedResourceGroup}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              filterOption={false}
              onChange={(value) => {
                setSelectedResourceGroup(value);
              }}
              loading={getResourceGroupLoading || savedFilterViewsLoading}
              showSearch={false}
              placeholder="Select a resource group"
              allowClear
            >
              <Option key="NAN" value={null}>
                All Work Centers
              </Option>
              {resourcesGroup && resourcesGroup?.data
                ?.filter((item) => (item?.resource_group_type === 'MACHINE'))
                .map((item) => (
                  <Option key={item.resource_group_id} value={item.resource_group_id}>
                    {`${item?.resource_group_name}`}
                  </Option>
                ))}
            </PRZSelect>
          </div>
          <div className="filter__container filter__container-section">
            <div className="filter__title">Machine</div>
            <PRZSelect
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              filterOption={false}
              value={selectedResource}
              onChange={(value) => {
                setSelectedResource(value);
              }}
            >
              <Option key="NAN" value={null}>
                All Machines
              </Option>
              {dropdownResources && dropdownResources?.data
                ?.filter((item) => (item?.type === 'Machine'))
                ?.map((item) => (
                  <Option key={item.resource_id} value={item.resource_id}>
                    {item?.resource_name}
                  </Option>
                ))}
            </PRZSelect>
          </div>
          <div className="filter__container filter__container-section">
            <div className="filter__title">Manufacturing Order Status</div>
            <div
              className="job-works__header__section-status"
            >
              <PRZSelect
                value={moStatus}
                onChange={(value) => {
                  setMOStatus(value);
                  setCurrentPage(1);
                }}
                placeholder="Order Status"
                options={orderStatusOptionsManufacturingOrders}
              />
            </div>
          </div>
          <SelectSeller
            isSubcontractor
            onChange={(value) => {
              setSelectedVendor(value?.seller_id);
            }}
            selectedSeller={selectedVendor}
            label="Subcontractor"
            containerClass="filter__container filter__container-section"
            inputClassName="job-works__header__section-status"
            labelClassName="filter__title"
            // showError={!selectedVendor}
            customStyle={{
              border: 'none !important',
            }}
            showAddVendor
            tenantId={user?.tenant_info?.tenant_id}
            getPopupContainer
            mapSellerId
            notRequired
          />
        </div>
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, DepartmentReducers, JobWorkReducers, TemplateRouteReducers, TenantReducers, ResourceReducers,
}) => ({
  user: UserReducers.user,
  departments: DepartmentReducers.departments,
  jobWorks: JobWorkReducers.jobWorks,
  getJobWorksLoading: JobWorkReducers.getJobWorksLoading,
  updateTemplateRouteStatusLoading: TemplateRouteReducers.updateTemplateRouteStatusLoading,
  updateAssigneeLoading: TemplateRouteReducers.updateAssigneeLoading,
  getJobOperatorsLoading: JobWorkReducers.getJobOperatorsLoading,
  jobOperators: JobWorkReducers.jobOperators,
  orgUsers: TenantReducers.orgUsers,
  dropdownResources: ResourceReducers.dropdownResources,
  resourcesGroup: ResourceReducers.resourcesGroup,
  getResourceGroupLoading: ResourceReducers.getResourceGroupLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getJobWorks: (payload, callback) => dispatch(JobWorkActions.getJobWorks(payload, callback)),
  getJobWorksSuccess: (jobWords) => dispatch(JobWorkActions.getJobWorksSuccess(jobWords)),
  getJobOperators: (payload, callback) => dispatch(JobWorkActions.getJobOperators(payload, callback)),
  updateTemplateRouteStatus: (payload, callback) => dispatch(TemplateRouteActions.updateTemplateRouteStatus(payload, callback)),
  getOrgUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
  updateAssignee: (payload, callback) => dispatch(TemplateRouteActions.updateAssignee(payload, callback)),
  getResource: (orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown) => dispatch(ResourceActions.getResource(orgId, page, limit, searchKeyword, tenantIds, resourceType, resourceStatus, isDropdown)),
  getResourceGroup: (orgId) => dispatch(ResourceActions.getResourceGroup(orgId)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobWorks));
